import React, { Fragment } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PaymentInstrumentList from '../paymentInstruments/PaymentInstrumentList';
import { useTranslate, Show, SimpleShowLayout, TextField, DateField } from 'react-admin';
import { Typography } from '@material-ui/core';
import { LinkField } from '../../components/fields';
import WalletShowActions from './WalletShowActions';
import WalletAccountList from '../walletAccounts/WalletAccountList';
import WalletNotificationListActions from '../walletNotifications/WalletNotificationListActions';
import WalletNotificationList from '../walletNotifications/WalletNotificationList';

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	show: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const WalletShow = props => {
	const translate = useTranslate();
	const classes = useStyles(props);
	return (
		<Fragment>
			<Show actions={<WalletShowActions />} {...props} className={classes.show}>
				<SimpleShowLayout>
					<TextField source="walletId" />
					<DateField source="creationDateTime" showTime />
					<TextField source="walletType" />
					<TextField source="walletStatus" />
					<TextField source="countryCode" />
					<TextField source="externalReferenceId" />
					<LinkField source="owner" />
				</SimpleShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.walletAccounts.name')}
			</Typography>
			<WalletAccountList
				perPage={5}
				{...props}
				title=" "
				basePath="/walletAccounts"
				resource="walletAccounts"
				filter={{ walletId: props.id }}
				className={classes.list}
			/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.paymentInstruments.name')}
			</Typography>
			<PaymentInstrumentList
				perPage={5}
				{...props}
				title=" "
				basePath={'/paymentInstruments'}
				resource={'paymentInstruments'}
				filter={{ walletId: props.id }}
				className={classes.list}
			/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.walletNotifications.name')}
			</Typography>
			<WalletNotificationList
				perPage={5}
				{...props}
				title=" "
				basePath={'/walletNotifications'}
				resource={'walletNotifications'}
				className={classes.list}
				actions={<WalletNotificationListActions id={props.id} />}
				filter={{ walletId: props.id }}
				hideWalletIdFilter={true}
			/>
		</Fragment>
	);
};

export default WalletShow;
